import { useEffect, useState } from 'react'
import { FileDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { MODULES, useModules } from '@/hooks/useModules'
import { showErrorToast } from '@/lib/toast'

import { getImportReceipt, getImportReceiptFileUrl, type ImportReceipt } from './winner-import.api'

interface WinnerSourceFileButtonProps {
  quoteId: string | undefined
  testId?: string
  /** Classes of a wrapper rendered only with the button, so a quote without receipt keeps its layout. */
  wrapperClassName?: string
}

/** On a quote imported from Winner: the original export, byte for byte. Nothing on any other quote. */
export function WinnerSourceFileButton({ quoteId, testId = 'editor-winner-source-btn', wrapperClassName }: WinnerSourceFileButtonProps) {
  const { hasModule } = useModules()
  const enabled = hasModule(MODULES.QUOTE_IMPORT)
  const [receipt, setReceipt] = useState<ImportReceipt | null>(null)

  useEffect(() => {
    if (!enabled || !quoteId) return
    let cancelled = false
    getImportReceipt(quoteId)
      .then((found) => { if (!cancelled) setReceipt(found) })
      .catch(() => { if (!cancelled) setReceipt(null) })
    return () => { cancelled = true }
  }, [enabled, quoteId])

  if (!enabled || !quoteId || !receipt) return null

  const download = async () => {
    try {
      const { url } = await getImportReceiptFileUrl(quoteId)
      window.open(url, '_blank', 'noopener,noreferrer')
    } catch {
      showErrorToast("Impossible d'ouvrir le fichier Winner")
    }
  }

  const button = (
    <Button variant="ghost" size="sm" className="gap-2" title={receipt.fileName} data-testid={testId} onClick={download}>
      <FileDown className="h-4 w-4" />
      Fichier Winner
    </Button>
  )
  return wrapperClassName ? <div className={wrapperClassName}>{button}</div> : button
}
